<template>
  <div id="login-div">

    <h1 class="page-title mt-2">
      {{ $t('registerTitle') }}
    </h1>
    <div class="mt-3 small-content">
      <span>{{ $t('register.Step') + " " + stepSignUp + '/' + maxStepSignUp }}</span>
      <b-progress :max="maxStepSignUp" :value="stepSignUp" class="custom-progress-bar" height="1em"
                  variant="primary"></b-progress>
    </div>
    <h2 class="content mt-4">
      {{ $t('registerSubtitle') }}
    </h2>

    <!-- Étape 1 -->
    <form v-if="stepSignUp === 1" class="mt-4" @submit.stop.prevent="nextStep">
      <!-- Contenu de l'étape 1 -->
      <b-form-group
        :invalid-feedback="form.username.invalidFeedback"
        :label="$t('loginFirstCredential')"
        class="small-text"
        label-for="username-input">
        <b-form-input
          id="username-input"
          v-model="form.username.value"
          :state="form.username.state"
          required
          type="email"
          v-on:change="removeInvalidFeedback('username')">
        </b-form-input>
      </b-form-group>

      <b-form-group
        :label="$t('loginSecondCredential')"
        class="small-text"
        label-for="password-input">
        <b-input-group>
          <b-form-input
            id="password-input"
            v-model="form.password.value"
            :state="form.password.state"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="off"
            class="form-input-with-right-append-inside"
            required>
          </b-form-input>
          <b-input-group-append>
            <div class="cursor-pointer custom-eye" @click.prevent="togglePassword">
              <i v-if="!showPassword" class="ph-custom ph-eye-fill"/>
              <i v-else class="ph-custom ph-eye-slash-fill"/>
            </div>
          </b-input-group-append>
        </b-input-group>
        <span v-if="!form.password.state" class="main-red-color"> {{ form.password.invalidFeedback }} </span>
      </b-form-group>

      <b-form-group
        :label="$t('signup.profile')"
        class="small-text"
        label-for="password-input">
        <div class="d-flex">
          <b-form-radio
            v-model="selectedProfile"
            class="mr-5"
            value="individual"
          >{{ $t('signup.individual') }}
          </b-form-radio>
          <b-form-radio
            v-model="selectedProfile"
            class="ml-5"
            value="professional"
          >{{ $t('signup.professional') }}
          </b-form-radio>
        </div>

      </b-form-group>

      <b-form-group
        :invalid-feedback="form.reason.invalidFeedback"
        :label="$t('Register.reason')"
        :state="form.reason.state"
        class="small-text"
        label-for="reason-input">
        <b-form-select
          id="reason-input"
          v-model="form.reason.value"
          :state="form.reason.state"
          required
          v-on:change="removeInvalidFeedback('reason')">
          <option
            v-for="reason in reasons"
            :key="reason.value"
            :value="reason.value">
            {{ reason.text }}
          </option>
        </b-form-select>
      </b-form-group>
      <div class="mt-5 d-flex justify-content-center flex-column align-items-center">
        <b-button class="btn-block" type="submit" variant="primary">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ $t('Next') }}</span> <i
            class="ph-custom ph-caret-circle-right-bold ml-1 align-self-center"/>
          </div>
        </b-button>
        <div class="mt-3 d-flex justify-content-center">
            <span class="content">
              {{ $t('Login.goToLogin') }}
            </span>
          <a class="ml-1 signup-link" @click="showLoginView">{{ $t('Login') }}</a>
        </div>
      </div>
    </form>

    <!-- Étape 2 -->
    <form v-if="stepSignUp === 2" class="mt-4" @submit.stop.prevent="nextStep">
      <!-- Contenu de l'étape 2 -->
      <div class="row">
        <div class="col-6">
          <b-form-group
            :invalid-feedback="form.lastname.invalidFeedback"
            :label="$t('user.Lastname')"
            class="small-text"
            label-for="lastname-input">
            <b-form-input
              id="lastname-input"
              v-model="form.lastname.value"
              :state="form.lastname.state"
              required
              v-on:change="removeInvalidFeedback('lastname')">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group
            :invalid-feedback="form.firstname.invalidFeedback"
            :label="$t('user.Firstname')"
            class="small-text"
            label-for="firstname-input">
            <b-form-input
              id="firstname-input"
              v-model="form.firstname.value"
              :state="form.firstname.state"
              required
              v-on:change="removeInvalidFeedback('firstname')">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-12">
          <date-field
            :class="'small-text'"
            :date-name="$t('user.Birthday')"
            :init-value="form.birthday.value"
            :invalid-feedback="form.birthday.invalidFeedback"
            :is-required="true"
            :min-date="minAge()"
            :mode="'date'"
            :state="form.birthday.state"
            @change="removeInvalidFeedback('birthday')"
            @dateInfos="handleDate"
          ></date-field>
          <b-form-invalid-feedback v-if="form.birthday.state === false" class="d-flex mb-2">{{
              $t(form.birthday.invalidFeedback)
            }}
          </b-form-invalid-feedback>
        </div>
        <div class="col-12">
          <div class="d-flex justify-content-center align-items-center custom-register-card">
            <div><i class="ph-bold ph-question-bold" style="font-size: 1.5rem"></i></div>
            <div>{{ $t('Register.not.show.other.data') }}</div>
          </div>
        </div>
      </div>

      <div class="mt-5 d-flex">
        <b-button class="w-50 mr-2 " variant="secondary" @click.prevent="prevStep">
          <div class="d-flex justify-content-center">
            <i class="ph-custom ph-caret-circle-left-bold mr-1 align-self-center"/><span
            class="align-self-center mt-small-px">{{ $t('Previous') }}</span>
          </div>
        </b-button>
        <b-button class="w-50" type="submit" variant="primary">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ $t('Next') }}</span> <i
            class="ph-custom ph-caret-circle-right-bold ml-1 align-self-center"/>
          </div>
        </b-button>
      </div>
    </form>

    <!-- Étape 3 -->
    <form v-if="stepSignUp === 3" class="mt-4" @submit.stop.prevent="onSubmit">
      <!-- Contenu de l'étape 3 -->
      <b-form-group
        :invalid-feedback="form.phoneNumber.invalidFeedback"
        :label="$t('user.PhoneNumber')"
        :state="form.phoneNumber.state"
        class="small-text"
        label-for="phoneNumber-input">
        <vue-phone-number-input
          id="phone-input"
          v-model="form.phoneNumber.inputValue"
          :dark="true"
          :error="form.phoneNumber.error"
          :placeholder="$t('user.phoneNumber')"
          dark-color="#303030"
          required
          @update="checkPhone"/>
      </b-form-group>

      <b-form-group
        v-if="countryCode === 'FR'"
        :invalid-feedback="form.department.invalidFeedback"
        :label="$t('user.Department')"
        :state="form.department.state"
        class="small-text mb-4"
        label-for="department-input">
        <b-form-select
          id="department-input"
          v-model="form.department.value"
          :state="form.department.state">
          <option v-for="department in departments" :value="department.serverId">
            {{ department.name }}
          </option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        :invalid-feedback="form.acceptedTerms.invalidFeedback"
        :state="form.acceptedTerms.state">
        <b-form-checkbox
          id="cgv-input"
          v-model="form.acceptedTerms.value"
          required
          v-on:change="removeInvalidFeedback('acceptedTerms')">
          <span v-html="$t('Register.Cgv')"></span>
        </b-form-checkbox>
      </b-form-group>

      <div class="mt-5 d-flex">
        <b-button class="w-50 mr-2 " variant="secondary" @click.prevent="prevStep">
          <div class="d-flex justify-content-center">
            <i class="ph-custom ph-caret-circle-left-bold mr-1 align-self-center"/><span
            class="align-self-center mt-small-px">{{ $t('Previous') }}</span>
          </div>
        </b-button>
        <b-button class="w-50" type="submit" variant="primary">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ $t('Next') }}</span> <i
            class="ph-custom ph-caret-circle-right-bold ml-1 align-self-center"/>
          </div>
        </b-button>
      </div>
    </form>

    <signup-professional-modal
      :redirectConnexionUrl="redirectProfessionalUrl"
      :username="username"
    ></signup-professional-modal>
  </div>
</template>

<script>

import {mapActions} from 'vuex'
import api from '../../../services/api'
import DateField from "../../../components/b122/editFields/DateField";
import i18n from "../../../i18n";
import SignupProfessionalModal from "../SignupProfessionalModal";

export default {

  name: 'SignUpComponent',

  components: {
    DateField,
    SignupProfessionalModal,
  },

  props: {
    username: {
      required: false,
    }
  },

  data() {
    return {
      stepSignUp: 1,
      maxStepSignUp: 3,
      departments: [],
      selectedProfile: 'individual',
      redirectProfessionalUrl: '',
      reasons: [
        {text: 'Inscrire mon véhicule volé', value: 'AnnonceCreate'},
        {text: 'Chercher des véhicules volés', value: 'Home'}
      ],
      form: {
        username: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        password: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        firstname: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        lastname: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        birthday: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        phoneNumber: {
          state: null,
          invalidFeedback: null,
          value: null,
          error: null,
        },
        department: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        reason: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        acceptedTerms: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },
      showPassword: false,
      countryCode: null
    }
  },

  watch: {
    'username': {
      immediate: true,
      handler() {
        if (this.username && this.username.trim().length > 0) {
          this.form.username.value = this.username
        }
      }
    },
    'form.reason.value': {
      handler(newValue) {
        if (newValue) {
          localStorage.setItem('selectedReason', newValue);
        }
      },
    },
  },

  emits: ['showLoginView', 'showValideAccount'],

  async mounted() {
    await this.fetchDepartments()
    await this.fetchRedirectConnexionUrl()
  },


  methods: {

    async fetchDepartments() {
      await api
        .get(`/apiMobile/getAllDepartments`)
        .then(response => {
          this.departments = response.data
        })
    },

    async fetchRedirectConnexionUrl() {
      const response = await api.get('/home/getEnvironmentLinks')
      this.redirectProfessionalUrl = response.data.proUrlLink
    },

    minAge() {
      const today = new Date();
      return new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    },


    async nextStep() {
      if (this.stepSignUp === 1 && this.selectedProfile === 'professional') {
        this.$bvModal.show('signup-professional-modal')
        return
      }

      if (this.stepSignUp < this.maxStepSignUp) {
        let formData = new FormData()
        formData.append('username', this.form.username.value.trim())
        formData.append('password', this.form.password.value)
        formData.append('firstname', this.form.firstname.value)
        formData.append('lastname', this.form.lastname.value)
        formData.append('birthday', this.form.birthday.value)
        formData.append('phoneNumber', this.form.phoneNumber.value ? this.form.phoneNumber.value.e164 : null)
        formData.append('department', this.form.department.value)
        formData.append('reason', this.form.reason.value)

        await api({
          method: 'POST',
          url: `/register/checkStep${this.stepSignUp}Register`,
          data: formData
        })
          .then(async (response) => {
            this.stepSignUp++;
          })
          .catch(error => {
            if (!error.response) {
              console.log("error", error)
            }
            if (error.response && error.response.status === 403) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]['state'] = false
              this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
              console.log(this.form[invalidField])
            }
          })
      }
    },

    prevStep() {
      if (this.stepSignUp > 1) {
        this.stepSignUp--;
      }
    },

    onSubmit() {
      let data = new FormData()

      data.append('lastname', this.form.lastname.value)
      data.append('firstname', this.form.firstname.value)
      data.append('phoneNumber', this.form.phoneNumber.value.e164)
      data.append('countryCode', this.form.phoneNumber.value.countryCode)
      data.append('username', this.form.username.value)
      data.append('password', this.form.password.value)
      data.append('birthday', this.form.birthday.value)
      data.append('acceptedTerms', this.form.acceptedTerms.value)

      if (this.form.department.value) {
        data.append('department', this.form.department.value)
      }

      api({
        method: 'POST',
        url: `register/signUpPublic`,
        data: data
      })
        .then((response) => {
          this.$emit('showValideAccount', response.data.username, this.form.password.value)
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && (error.response.status === 401 || error.response.status === 404)) {
            this.$router.push({
              name: 'Login',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response && error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    resendValidateAccountMail() {

      let formData = new FormData()
      formData.append('username', this.form.username.value.trim())

      api({
        method: 'POST',
        url: `/authentication/resendValidateAccountMail`,
        data: formData
      })
        .then(() => {
          this.ui.showResendValidateAccountMailSuccess = true
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },

    showLoginView() {
      this.$emit('showLoginView')
    },

    goToHome() {
      this.$router.push({
        name: 'Home'
      })
    },

    togglePassword() {
      this.showPassword = !this.showPassword
    },

    handleDate(index, state, invalidFeedback, value) {
      this.form.birthday.state = state;
      this.form.birthday.invalidFeedback = invalidFeedback;
      this.form.birthday.value = value;

      if (this.calculateAge(value) < 17) {
        this.form.birthday.state = false;
        this.form.birthday.invalidFeedback = this.$t('minor.error');
      }
    },

    calculateAge(birthday) {
      const birthDate = new Date(birthday);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },


    checkPhone(value) {
      this.countryCode = value.countryCode
      this.form.phoneNumber.error = false
      this.form.phoneNumber.value = value
      this.removeInvalidFeedback('phoneNumber')
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

  }

}

</script>

<style scoped>

.custom-register-card {
  background-color: var(--main-black-medium);
  border-radius: 5px;
  padding: 5px 10px 5px 10px;
  gap: 10px;
  font-weight: 400;
  font-size: 16px;
  color: var(--main-grey-medium);
}


.custom-eye {
  border: 1px solid var(--main-grey-dark) !important;
  border-left: none;
  border-top-right-radius: var(--form-control-border-radius);
  border-bottom-right-radius: var(--form-control-border-radius);
  padding-left: 1em;
  padding-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--main-grey-medium) !important;
  background-color: var(--main-black-medium) !important;
}

.custom-control {
  z-index: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/views/auth/components/SignUpComponent.vue